<template>
  <div class="azcon-statistics-card">
    <h2>{{ $t('general.statistics') || 'İstatistikler' }}</h2>
    <div class="azcon-statistics-card__grid">
      <template v-if="isLoading">
        <div v-for="n in 4" :key="`stat-skeleton-${n}`" class="azcon-statistics-card__item azcon-statistics-card__item--skeleton">
          <div class="azcon-statistics-card__skeleton-value shimmer"></div>
          <div class="azcon-statistics-card__skeleton-label shimmer"></div>
        </div>
      </template>
      <template v-else>
        <router-link v-for="stat in stats" :key="stat.key" :to="stat.route" class="azcon-statistics-card__item">
          <p class="azcon-statistics-card__value">{{ stat.value }}</p>
          <p class="azcon-statistics-card__label">{{ stat.label }}</p>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AzconStatisticsCard",
  props: {
    dashboardItem: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      assignmentCounts: {},
      certificatesCount: null,
      assignmentCountsLoading: true,
      certificatesLoading: true,
    };
  },
  computed: {
    isLoading() {
      return this.loading || this.assignmentCountsLoading || this.certificatesLoading;
    },

    stats() {
      const certificatesValue = this.certificatesCount !== null
        ? this.certificatesCount
        : (this.dashboardItem.certificates_count || 0);

      return [
        {
          key: "all",
          value: this.getCount("all", "total"),
          label: this.$t('general.assigned_educations') || "Atanan Eğitimler",
          route: { name: 'user.my-assignment', query: { tab: 'with_expired', val: 'false' } },
        },
        {
          key: "on_progress",
          value: this.getCount("on_progress"),
          label: this.$t('general.on_going_educations') || "Devam Edenler",
          route: { name: 'user.my-assignment', query: { tab: 'on_progress', val: 'true' } },
        },
        {
          key: "completed",
          value: this.getCount("completed"),
          label: this.$t('general.completed_educations') || "Tamamlananlar",
          route: { name: 'user.my-assignment', query: { tab: 'completed', val: 'true' } },
        },
        {
          key: "certificates",
          value: certificatesValue,
          label: this.$t('general.certificates') || "Sertifikalarım",
          route: { name: 'User.my-certification' },
        },

      ];
    },
  },
  mounted() {
    this.loadAssignmentCounts();
    this.loadCertificatesCount();
  },
  methods: {
    getCount(...keys) {
      for (const key of keys) {
        const value = this.assignmentCounts?.[key];
        if (value !== undefined && value !== null) {
          return value;
        }
      }

      return 0;
    },

    async loadAssignmentCounts() {
      this.assignmentCountsLoading = true;
      try {
        const response = await axios.get("api/assignment/counts");
        this.assignmentCounts = response?.data || {};
      } catch (error) {
        console.error('Failed to fetch assignment counts:', error);
      } finally {
        this.assignmentCountsLoading = false;
      }
    },

    async loadCertificatesCount() {
      this.certificatesLoading = true;
      try {
        const response = await axios.get("api/get-certificates", {
          params: {
            page: 1,
            perPage: 1,
            search: '',
            order_by: 'created_at',
          },
        });

        this.certificatesCount = response?.data?.total ?? 0;
      } catch (error) {
        console.error('Failed to fetch certificate total:', error);
      } finally {
        this.certificatesLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.azcon-statistics-card {
  h2 {
    margin: 0 0 12px;
    font-size: 20px;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  &__item {
    text-decoration: none;
    color: inherit;
    display: block;
  }

  &__item--skeleton {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__value {
    margin: 0;
    font-size: 26px;
    font-weight: 800;
  }

  &__label {
    margin: 2px 0 0;
    color: #6a788b;
    font-size: 13px;
  }

  &__skeleton-value {
    width: 50px;
    height: 26px;
    border-radius: 6px;
  }

  &__skeleton-label {
    width: 90px;
    height: 13px;
    border-radius: 4px;
  }
}

.shimmer {
  position: relative;
  overflow: hidden;
  background-color: #dfe5ee;
}

.shimmer::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.55), transparent);
  animation: shimmer-slide 1.1s infinite;
}

@keyframes shimmer-slide {
  100% {
    transform: translateX(100%);
  }
}

@media (min-width: 1024px) {
  .azcon-statistics-card {
    h2 {
      font-size: 22px;
    }

    &__grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}

</style>
